// export this package's api
'use strict';

module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-notification/~/rc-animate/lib/index.js
 ** module id = 463
 ** module chunks = 0
 **/